var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiggyBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PiggyBank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M21.1569 9H21.5C21.8978 9 22.2794 9.15804 22.5607 9.43934C22.842 9.72064 23 10.1022 23 10.5V13.5C23 13.8978 22.842 14.2794 22.5607 14.5607C22.2794 14.842 21.8978 15 21.5 15H20.75L19.0531 19.7522C19.0011 19.898 18.9052 20.0241 18.7786 20.1132C18.6521 20.2023 18.501 20.2501 18.3463 20.25H17.1538C16.999 20.2501 16.8479 20.2023 16.7214 20.1132C16.5948 20.0241 16.4989 19.898 16.4469 19.7522L16.0897 18.75H9.66032L9.30313 19.7522C9.25108 19.898 9.1552 20.0241 9.02864 20.1132C8.90208 20.2023 8.75105 20.2501 8.59625 20.25H7.40375C7.24896 20.2501 7.09793 20.2023 6.97137 20.1132C6.84481 20.0241 6.74893 19.898 6.69688 19.7522L5.46875 16.3125C4.20064 14.9317 3.49791 13.1247 3.5 11.25C3.5 9.26088 4.29018 7.35322 5.6967 5.9467C7.10323 4.54018 9.01088 3.75 11 3.75H14C15.4635 3.74958 16.8952 4.17736 18.1186 4.98062C19.342 5.78388 20.3036 6.92753 20.885 8.27063C20.9879 8.50902 21.0786 8.75245 21.1569 9Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.375 12C17.9963 12 18.5 11.4963 18.5 10.875C18.5 10.2537 17.9963 9.75 17.375 9.75C16.7537 9.75 16.25 10.2537 16.25 10.875C16.25 11.4963 16.7537 12 17.375 12Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11 6.75H14.75",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.75 3.75H14",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1.25 13.5C1.25 12.9033 1.48705 12.331 1.90901 11.909C2.33097 11.4871 2.90326 11.25 3.5 11.25",
    stroke: "#FFB600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.1569 9H21.5C21.8978 9 22.2794 9.15804 22.5607 9.43934C22.842 9.72065 23 10.1022 23 10.5V13.5C23 13.8978 22.842 14.2794 22.5607 14.5607C22.2794 14.842 21.8978 15 21.5 15H20.75L19.0531 19.7522C19.0011 19.898 18.9052 20.0241 18.7786 20.1132C18.6521 20.2023 18.501 20.2501 18.3463 20.25H17.1538C16.999 20.2501 16.8479 20.2023 16.7214 20.1132C16.5948 20.0241 16.4989 19.898 16.4469 19.7522L16.0897 18.75H9.66032L9.30313 19.7522C9.25108 19.898 9.1552 20.0241 9.02864 20.1132C8.90208 20.2023 8.75105 20.2501 8.59625 20.25H7.40375C7.24896 20.2501 7.09793 20.2023 6.97137 20.1132C6.84481 20.0241 6.74893 19.898 6.69688 19.7522L5.46875 16.3125C4.20064 14.9317 3.49791 13.1247 3.5 11.25C3.5 9.26088 4.29018 7.35322 5.6967 5.9467C7.10323 4.54018 9.01088 3.75 11 3.75H14C15.4635 3.74958 16.8952 4.17736 18.1186 4.98062C19.342 5.78388 20.3036 6.92753 20.885 8.27063C20.9879 8.50902 21.0786 8.75245 21.1569 9Z",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBank);
export default __webpack_public_path__ + "static/media/PiggyBank.e605111d5e15d52904d8d9eec3bca859.svg";
export { ForwardRef as ReactComponent };